import React, { useContext, useState } from "react";
import { CommonOutletTemplate } from "UI/CommonOutletTemplate";
import { EditUserDialog } from "./EditUserDialog";
import { useDataGrid } from "hooks/useDataGrid";
import * as CSC from "SC";
import { GlobalContext } from "store/globalContext";
import { DataGrid } from "UI/DataGrid";
import { AddNewRecipientUserDialog } from "./AddNewRecipientUserDialog";
import { useRegions } from "hooks/useRegions";
import { TextFieldWithEllipsis } from "UI/TextFiledWithEllipsis";

const columns = [
  {
    label: "Name",
    field: "name",
    xs: 3,
    sm: 3,
    md: 3,
  },
  {
    label: "Role",
    field: "role",
    xs: 2,
    sm: 2,
    md: 2,
  },
  {
    label: "Email",
    field: "email",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ email }) => (
      <TextFieldWithEllipsis>{email}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Phone",
    field: "phone",
    xs: 2,
    sm: 2,
    md: 2,
  },
  {
    label: "Region",
    field: "label",
    xs: 2,
    sm: 2,
    md: 2,
  },
];

const mobileColumns = [
  {
    label: "Name",
    field: "name",
    xs: 4,
    sm: 4,
    md: 4,
  },
  {
    label: "Role",
    field: "role",
    xs: 2,
    sm: 2,
    md: 2,
  },
  {
    label: "Email",
    field: "email",
    xs: 6,
    sm: 6,
    md: 6,
    renderer: ({ email }) => (
      <TextFieldWithEllipsis>{email}</TextFieldWithEllipsis>
    ),
  },
];

export const RecipientUsers = () => {
  const [isAddNewDialogOpen, setIsAddNewDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const { userData } = useContext(GlobalContext);
  const { regionsOptions, refreshRegionsOptions } = useRegions();

  const dataGrid = useDataGrid({
    url: "/users/list",
    defaultSorter: {
      name: "name",
      order: "asc",
    },
    defaultLimit: 25,
    gridConfigIndex: `${userData.cognitoId}-RecipientUsers`,
  });

  const handleRowClick = (row) => {
    setSelectedUser(row);
  };

  return (
    <CommonOutletTemplate title="Users" isLoading={!dataGrid?.rows}>
      <DataGrid
        columns={columns}
        mobileColumns={mobileColumns}
        handleRowClick={handleRowClick}
        {...dataGrid}
        afterSearchContent={
          <CSC.BlueButton
            variant="outlined"
            onClick={() => setIsAddNewDialogOpen(true)}
          >
            Add New User
          </CSC.BlueButton>
        }
      />
      {isAddNewDialogOpen && (
        <AddNewRecipientUserDialog
          open={isAddNewDialogOpen}
          handleClose={() => setIsAddNewDialogOpen(false)}
          refreshList={() => dataGrid.loadData()}
          regionsOptions={regionsOptions}
          refreshRegionsOptions={refreshRegionsOptions}
          recipientName={userData?.organization}
        />
      )}
      {
        // @ts-ignore
        selectedUser?.id && (
          <EditUserDialog
            selectedUser={selectedUser}
            handleClose={() => setSelectedUser({})}
            refreshList={dataGrid.loadData}
            regionsOptions={regionsOptions}
            refreshRegionsOptions={refreshRegionsOptions}
          />
        )
      }
    </CommonOutletTemplate>
  );
};
